import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';
import { getToken, setToken, setUser as storeUser, clearAuth, setMustResetPassword as storeMRP } from '../lib/tokenStorage';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mustResetPassword, setMustResetPassword] = useState(false);

  useEffect(() => {
    const token = getToken();
    if (token) {
      authAPI.me()
        .then(res => {
          setUser(res.data);
          if (res.data.must_reset_password) {
            setMustResetPassword(true);
            storeMRP(true);
          } else {
            setMustResetPassword(false);
            storeMRP(false);
          }
        })
        .catch(() => { clearAuth(); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    clearAuth();
    const res = await authAPI.login({ email, password });
    setToken(res.data.token);
    storeUser(res.data.user);
    setUser(res.data.user);
    if (res.data.must_reset_password) {
      setMustResetPassword(true);
      storeMRP(true);
    }
    return res.data;
  };

  const completePasswordReset = async (currentPw, newPw) => {
    await authAPI.resetPassword({ current_password: currentPw, new_password: newPw });
    setMustResetPassword(false);
    storeMRP(false);
    // Refresh user to clear must_reset_password flag
    try {
      const res = await authAPI.me();
      setUser(res.data);
    } catch {}
  };

  const logout = async () => {
    try { await authAPI.logout(); } catch {}
    clearAuth();
    setUser(null);
    setMustResetPassword(false);
  };

  const refreshUser = async () => {
    try {
      const res = await authAPI.me();
      setUser(res.data);
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser, mustResetPassword, completePasswordReset }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}
